module.exports = __webpack_public_path__ + "img/all_interfaces.d7b5cbbb.png";